/*********************
 Early Reader Rule
 *********************/
import Rule from '../Rule';
import {ruleTypes} from '../../../constants';
import {buildLogForRule} from "../../../utils/logUtils";

export default class EarlyReaderRule extends Rule {
  constructor(logic) {
    super([], logic);
    this.ruleType = ruleTypes.EARLY_READER;
  }

  run(state) {
    const {
      isEarlyReader: isEnglishEarlyReader,
      isSpanishEarlyReader,
      locale,
    } = state;
    const isEarlyReader =
      (locale.toLowerCase() === "en-us" && isEnglishEarlyReader) ||
      (locale.toLowerCase() === "es-mx" && isSpanishEarlyReader);
    const meetsRuleCondition = this.logic(isEarlyReader);
    return {
      stateMeetsRuleCondition: meetsRuleCondition,
      decisionContext: {[(this.ruleType + '_' + meetsRuleCondition)]: 'isEarlyReader:' + isEarlyReader},
      log: buildLogForRule(this, state, meetsRuleCondition, {isEarlyReader}),
    }
  }
}
